import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { InputText } from 'primeng/inputtext';
import { FormErrorsComponent } from '../../../shared/components/form-errors/form-errors.component';
import { AuthService } from '../../../core/services/auth.service';
import { ToastMessageService } from '../../../core/services/toast-message.service';
import { StorageService } from '../../../core/services/storage.service';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { ValidationService } from '../../../core/services/validation.service';

@Component({
  selector: 'app-login',
  imports: [
    CardModule,
    InputText,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsComponent,
    ButtonModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup = new FormGroup({});
  loadingSubmit: boolean = false;

  constructor(
    private authService: AuthService,
    private toasterService: ToastMessageService,
    private storageService: StorageService,
    private route: Router,
    private validationService: ValidationService
  ) { }

  ngOnInit() {
    this.setLoginForm();
  }

  setLoginForm() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(this.validationService.emailRegex)]),
      password: new FormControl('', [Validators.required, Validators.pattern(this.validationService.passwordRegex)]),
    })
  }

  login() {
    if (this.loginForm.valid) {
      this.loadingSubmit = true;
      this.authService.login(this.loginForm.value).subscribe({
        next: (resp: any) => {
          this.loadingSubmit = false;
          this.toasterService.toastOnSuccess('Success', "You logged in successfully");
          this.storageService.setToken(resp?.user?.token);
          this.storageService.setUserRole(resp?.user?.role.name);
          // this.storageService.setUserRole("super_admin");
          this.storageService.setUserData(resp?.user);
          this.route.navigate(['/dashboard']);
        }, error: error => {
          this.loadingSubmit = false;

        }
      })
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
